// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface File1IconSignature {
  Element: SVGSVGElement;
}

export const File1Icon: TOC<File1IconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M6 2H15.414L20 6.586V20C20 21.103 19.103 22 18 22H6C4.897 22 4 21.103 4 20V4C4 2.898 4.897 2 6 2ZM6 20H18.001L18 8H14V4H6V20Z"/>
</svg>
</template>;